import React from 'react';
import { Star } from 'lucide-react';

const RatingStars = ({ rating, size = 'md', interactive = false, onRate }) => {
  const sizeMap = { sm: 'w-3.5 h-3.5', md: 'w-5 h-5', lg: 'w-6 h-6' };
  const iconSize = sizeMap[size] || sizeMap.md;

  return (
    <div className="flex items-center gap-0.5" data-testid="rating-stars">
      {[1, 2, 3, 4, 5].map((star) => (
        <button
          key={star}
          type="button"
          disabled={!interactive}
          onClick={() => interactive && onRate?.(star)}
          className={interactive ? 'cursor-pointer hover:scale-110 transition-transform' : 'cursor-default'}
          data-testid={`star-${star}`}
        >
          <Star
            className={`${iconSize} ${star <= rating ? 'fill-[#C29B57] text-[#C29B57]' : 'fill-none text-[#EBE4D5]'}`}
          />
        </button>
      ))}
    </div>
  );
};

export default RatingStars;
